/* eslint-disable no-mixed-operators */
import { merge } from 'lodash'

function getLocation(href) {
  const l = document.createElement('a')
  l.href = href
  return l
}

export function replaceRestfulParams(url, params) {
  const path = getLocation(url).pathname
  const restParamSegReg = /:([^/]*)/g
  const replacedPath = path.replace(restParamSegReg, (_, seg) => {
    let val = params[seg]
    if (val === undefined) {
      val = `:${seg}`
    }
    return val
  }).replace('//', '/')
  return url.replace(path, replacedPath)
}

function stringifyQueryObj(queryObj) {
  return Object.keys(queryObj).map(
    key => `${key}=${encodeURIComponent(queryObj[key])}`,
  ).join('&')
}

export function concatQuery(url, query = {}) {
  if (Object.keys(query).length === 0) {
    return url
  }
  if (url.indexOf('?') === -1) {
    url = `${url}?`
  }
  const stringifiedQuery = stringifyQueryObj(query)
  if (url[url.length - 1] === '?') {
    return `${url}${stringifiedQuery}`
  }
  return `${url}&${stringifiedQuery}`
}

export function deepMerge(...args) {
  return merge({}, ...args)
}

export function objPropContainStr(
  obj,
  prop,
  expectedContainStr,
  propKeyCaseInsenstive = true,
) {
  let value = obj[prop] || ''
  if (value.indexOf(expectedContainStr) > -1) {
    return true
  }
  if (propKeyCaseInsenstive) {
    value = obj[
      prop.toLowerCase()
    ] || ''
    if (value.indexOf(expectedContainStr) > -1) {
      return true
    }
  }
  return false
}

export function getUniqId() {
  return Math.random().toString(36).substr(2, 9)
}
export function getLocale(url = window.location.href) {
  const query = url.split('?')[1]
  if (!query) {
    return 'zh'
  }
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i += 1) {
    const kv = vars[i].split('=')
    if (kv[0] === 'locale') {
      if (['zh', 'en'].indexOf(kv[1]) < 0) {
        return 'zh'
      }
      return kv[1]
    }
  }
  return 'zh'
}
export function getQueryParams(params, url) {
  const query = url && url.split('?')[1] || window.location.href.split('?')[1]
  let result = ''
  if (query) {
    const vars = query.split('&')
    for (let i = 0; i < vars.length; i += 1) {
      const kv = vars[i].split('=')
      if (kv[0] === params) {
        result = kv[1]
      }
    }
  }
  return result
}
export function textToUrl(text) {
  text = text && text.replace(/\n/g, '<br/>')
  text = text && text.replace(/↵/g, '<br/>')
  const marchingArr = text && text.match(/[https?://]?[-A-Za-z0-9+&@#/%?=~_|!:,.;]+\.[-A-Za-z+&@#/%=?~_|]+\.[-A-Za-z0-9+&@#/%=?~_|]+/g)
  if (marchingArr) {
    marchingArr.forEach(val => {
      const v = val.replace(/\?/, '\\?')
      text = text && text.replace(new RegExp(v, 'g'), `<a target="_blank" href="${val}">${val}</a>`)
    })
  }
  return text
}
